import React from 'react';

import { Page } from 'components/modules/AutoruLayout/Page/Page';
import { PageContent } from 'components/modules/AutoruLayout/PageContent/PageContent';

import { Stepper } from '../Stepper/Stepper';

export const InsuranceProducts = () => {
  return (
    <Page aside={<Stepper />}>
      <PageContent title="Продукты страхования"></PageContent>
    </Page>
  );
};
